import * as api from "../api/index";

export const ChannelService = {
  createChannel,
  createDataChannel,
  updateChannel,
  updateDataChannel,
  getChannelList,
  getDataChannelList,
  getChannelListWithoutPagination,
  getDataChannelListWithoutPagination,
};

async function createChannel(formData) {
  try {
    const { data } = await api.createChannel(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createDataChannel(formData) {
  try {
    const { data } = await api.createDataChannel(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateChannel(formData) {
  try {
    const { data } = await api.updateChannel(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateDataChannel(formData) {
  try {
    const { data } = await api.updateDataChannel(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getChannelList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getChannelList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getDataChannelList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getDataChannelList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getChannelListWithoutPagination() {
  try {
    const { data } = await api.getChannelListWithoutPagination();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getDataChannelListWithoutPagination() {
  try {
    const { data } = await api.getDataChannelListWithoutPagination();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}